export class UserTagType {
  public userTagTypeId: number;
  public userTagCategory: string;
  public userTagName: string;
  public userTagKey1: string;
  public userTagKey2: string;
  public userTagKey3: string;
  constructor(userTagTypeId: number, options: any = {}) {
    this.userTagTypeId = userTagTypeId;
    this.userTagCategory = options.userTagCategory ?? "";
    this.userTagName = options.userTagName ?? "";
    this.userTagKey1 = options.userTagKey1 ?? "";
    this.userTagKey2 = options.userTagKey2 ?? "";
    this.userTagKey3 = options.userTagKey3 ?? "";
  }
}

export const tagTypeUniqeId = (tag: UserTagType) =>
  `${tag.userTagTypeId}` + `${tag.userTagKey1}` + `${tag.userTagKey2}` + `${tag.userTagKey3}`;
